import { useMemo } from 'react'
import { StockType } from 'types/stock'

const useHasChangedStock = (prevStocks: StockType[], nextStocks: StockType[], isNoStock: boolean): boolean => {
  return useMemo(() => {
    if (isNoStock) return true
    return prevStocks.some((prevStock) =>
      nextStocks.some(
        (nextStock) => nextStock.stock_ref?.id === prevStock.stock_ref?.id && nextStock.stock !== prevStock.stock
      )
    )
  }, [prevStocks, nextStocks, isNoStock])
}

export default useHasChangedStock
